import PartnershipsComponent from "../components/partnerships/partnerships-component"

const PartnershipsPage = () => {
    return <PartnershipsComponent />
}

export default PartnershipsPage;